import { findViewAvatarByMatrixUserId } from '@/modules/chat-matrix-fast/stores/chatStoreSync'
import { resolvePeerAvatarFromBackend } from '@/modules/chat-matrix-fast/services/employeeLookup'
import { normalizeAvatarUrl } from '@/modules/chat-matrix-fast/utils/userDataExtractor'

export async function resolveDialogPeerAvatar(
  peerMxid?: string | null,
  _roomId?: string | null,
  hintedIcon?: string | null,
): Promise<string | null> {
  const hinted = normalizeAvatarUrl(hintedIcon)
  if (hinted && !hinted.includes('/_matrix/')) {
    return hinted
  }

  const fromContacts = peerMxid ? findViewAvatarByMatrixUserId(peerMxid) : null
  if (fromContacts) {
    return fromContacts
  }

  if (!peerMxid?.trim()) {
    return null
  }

  return resolvePeerAvatarFromBackend(peerMxid.trim())
}
